import { baseUrl } from 'infra/config/aws-env'
import { InsightsService } from 'infra/services/insights-service'
import { makeAxiosHttpClient } from '../http/axios-http-client-factory'

export const makeInsightsService = () => new InsightsService(baseUrl, makeAxiosHttpClient())
